<div
  class="ozonetel-iframe-container"
  [class.minimized]="isMinimized"
  [style.transform]="getTransform()">
  <div class="ozonetel-header" (mousedown)="onMouseDown($event)">
    <span class="ozonetel-title">Ozonetel Agent</span>
    <div class="ozonetel-controls">
      <button class="control-btn" (click)="toggleMinimize()" [title]="isMinimized ? 'Expand' : 'Collapse'">
        @if (!isMinimized) {
          <mat-icon>expand_more</mat-icon>
        }
        @if (isMinimized) {
          <mat-icon>expand_less</mat-icon>
        }
      </button>
    </div>
  </div>

  @if (!isMinimized) {
    <div class="ozonetel-iframe-wrapper">
      <iframe
        [src]="iframeUrl"
        frameborder="0"
        allow="microphone; camera; autoplay"
        class="ozonetel-iframe">
      </iframe>
    </div>
  }
</div>
